import React from 'react'

function Footer() {
	return (
		<div>
			<footer id="footer" className="footer ">
				<div className="footer-top">
					<div className="container">
						<div className="row">
							<div className="col-lg-3 col-md-6 col-12">
								<div className="single-footer">
									<h2>About Us</h2>
									<p>
										Webnet Technologies is a trusted healthcare provider committed to offering high-quality, patient-centric medical services with compassion, innovation, and integrity.
									</p>
									<ul className="social">
										<li><a href="https://www.facebook.com/WebnetTechnologiespatna" target='blank' aria-label="Facebook"><i className="icofont-facebook"></i></a></li>
										{/* <li><a href="#" aria-label="Google Plus"><i className="icofont-google-plus"></i></a></li> */}
										<li><a href="https://twitter.com/WebnetTechnologies" target='blank' aria-label="Twitter"><i class="fa-brands fa-x-twitter"></i></a></li>
										<li><a href="https://www.instagram.com/webnettechnologies/" target='blank' aria-label="instagram"><i className="icofont-instagram"></i></a></li>
										<li><a href="https://www.linkedin.com/in/webnet-technologies-a451ab292/?originalSubdomain=in:" aria-label="linkedin"><i className="icofont-linkedin"></i></a></li>
									</ul>

								</div>
							</div>
							<div className="col-lg-3 col-md-6 col-12">
								<div className="single-footer f-link">
									<h2>Quick Links</h2>
									<div className="row">
										<div className="col-lg-6 col-md-6 col-12">
											<ul>
												<li><a href="/Home"><i className="fa fa-caret-right" aria-hidden="true"></i> Home</a></li>
												<li><a href="/overview"><i className="fa fa-caret-right" aria-hidden="true"></i> About</a></li>
												{/* <li><a href="/app2/portfolio"><i className="fa fa-caret-right" aria-hidden="true"></i> Portfolio</a></li> */}

												<li><a href="/contactus"><i className="fa fa-caret-right" aria-hidden="true"></i> Contact Us</a></li>
												<li><a href="/blogs"><i className="fa fa-caret-right" aria-hidden="true"></i> Blog</a></li>
												<li><a href="/faqs"><i className="fa fa-caret-right" aria-hidden="true"></i> FAQ</a></li>
												{/* <li><a href="/src/Pages/OtherLinks.jsx"><i className="fa fa-caret-right" aria-hidden="true"></i> Other Links</a></li> */}
											</ul>

										</div>
										<div className="col-lg-6 col-md-6 col-12">
											<ul>
												{/* <li><a href="#"><i className="fa fa-caret-right" aria-hidden="true"></i> Consulting</a></li>
												<li><a href="#"><i className="fa fa-caret-right" aria-hidden="true"></i> Finance</a></li>
												<li><a href=""><i className="fa fa-caret-right" aria-hidden="true"></i> Testimonials</a></li> */}

												{/* <li><a href="/app2/faqs"><i className="fa fa-caret-right" aria-hidden="true"></i> Faqs</a></li>	 */}


											</ul>

										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6 col-12">
								<div className="single-footer">
									<h2>Open Hours</h2>
									<p>We’re here to care for you when you need us most. Find our weekly schedule below:</p>
									<ul className="time-sidual">
										<li className="day">Time :-<span>10:00 AM - 06:00 PM</span></li>
										{/* <li className="day">Saturday <span>09:00 AM - 06:30 PM</span></li> */}
										{/* <li className="day">Sunday <span>Closed</span></li> */}
									</ul>
								</div>
							</div>
							<div className="col-lg-3 col-md-6 col-12">
								<div className="single-footer">
									<h2>Newsletter</h2>
									<p>Stay informed with the latest health tips, wellness updates, and clinic news. Subscribe to our newsletter and never miss an update from our medical team.</p>

									<form action="#" method="get" target="_blank" className="newsletter-inner">
										<input name="email" placeholder="Email Address" className="common-input" onfocus="this.placeholder = ''"
											onblur="this.placeholder = 'Your email address'" required="" type="email" />
										<button className="button"><i className="icofont icofont-paper-plane"></i></button>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="copyright">
					<div className="container">
						<div className="row">
							<div className="col-lg-12 col-md-12 col-12">
								<div className="copyright-content">
									<p>© Copyright {new Date().getFullYear()} | All Rights Reserved by <a href="https://webnettechnologies.in" target="_blank" rel="noopener noreferrer">Webnet Technologies</a></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>

		</div>
	)
}

export default Footer